
// Note: carried errorThunks out of errorSlice because cypress could not complie getSdk() dependency

import {
  NQError,
  WarningDE,
  AbortSchemeRequestModel,
} from '@visonum/network-quality-sdk';
import { AppThunk } from '../../store';
import { logger } from '../../helper/logger';
import { sentryReportWarning } from '../sentryReports/sentryCaptureError';
import { getSdk } from 'src/networkQuality';
import { selectSpeedtestId } from './utils';
import { catchError, EMPTY } from 'rxjs';
import { reportNQError } from './errorSlice';


enum Severity {
  Warning = "warning",
  Error = "error",
}

export const reportError = (error: NQError): AppThunk => async (dispatch, getState) => {
  dispatch(reportNQError(error));
  logger.debug("abortSchemeError: ", error);
  const payload: AbortSchemeRequestModel = {
    speedtestId: selectSpeedtestId() ?? undefined,
    uuid: getSdk().clientId(),
    severity: Severity.Error,
    scheme: error.scheme,
    message: error.message,
    additionalInfo: error.additionalInfo ?? undefined
  }

  getSdk().abortScheme(payload).pipe(
    catchError(err => {
      logger.warn("AbortSchemeError failed:", err);
      return EMPTY;
    })
  ).subscribe();

};


export const reportWarning = (warning: WarningDE): AppThunk => async (dispatch, getState) => {
  logger.warn(warning.message, { url: warning.url });

  const payload: AbortSchemeRequestModel = {
    speedtestId: selectSpeedtestId() ?? undefined,
    uuid: getSdk().clientId(),
    severity: Severity.Warning,
    scheme: undefined,
    message: warning.message,
    additionalInfo: warning.url
  }

  getSdk().abortScheme(payload).pipe(
    catchError(err => {
      logger.warn("AbortSchemeWarning failed:", err);
      return EMPTY;
    })
  ).subscribe();

  sentryReportWarning(warning);
}